import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';

import { MatCard, MatCardContent } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

// TODO: make this modal common too, try to implement logic that will not depend on @hm-portal injections
// TODO: adjust component to prevent app->lib dependency (only lib->app)
//       make this modal a part of shared-ui lib too
import { PrescriptionLimitsModalComponent } from '@hm/ui/modals/prescriptions/prescription-limits-modal/prescription-limits-modal.component';

import { LimitRule, LimitType, RuleMessage } from '@lib/core/models/insurance-package.interface';

import { SpinLoadingComponent } from '@lib/shared-ui/commons/spin-loading/spin-loading.component';

@Component({
  selector: 'shared-limit',
  standalone: true,
  imports: [SpinLoadingComponent, CdkOverlayOrigin, CdkConnectedOverlay, MatCard, MatCardContent, MatIcon, MatTooltip, NgClass],
  templateUrl: './limit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LimitComponent {
  private readonly dialog = inject(MatDialog);

  protected readonly type = LimitType;

  loadingLimits = input.required<boolean>();
  limits = input.required<LimitRule[] | null>();

  protected readonly limitCardIsOpen = signal<boolean>(false);

  protected setRuleMessage(limit: LimitRule): string {
    return RuleMessage[limit.limitRuleName];
  }

  protected toggleTemplate(toggle: boolean) {
    if (this.limits() && this.limits()!.length > 0) {
      this.limitCardIsOpen.set(toggle);
    }
  }

  protected openPrescriptionLimitsModal() {
    if (!this.limits() || this.limits()!.length === 0) {
      return;
    }
    this.dialog.open(PrescriptionLimitsModalComponent, {
      minWidth: '600px',
      width: '720px',
      autoFocus: false,
      data: { limits: this.limits() },
    });
  }
}
